import React, { createContext, useContext, useMemo, useState } from 'react';
import adminApi from './adminApi';

const AdminAuthContext = createContext(null);

function persistAdmin(nextAdmin) {
  if (nextAdmin) {
    localStorage.setItem('cw_admin_profile', JSON.stringify(nextAdmin));
    return;
  }

  localStorage.removeItem('cw_admin_profile');
}

function setAdminSession(token, admin) {
  localStorage.setItem('cw_admin_token', token);
  persistAdmin(admin);
}

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(() => {
    try {
      const stored = localStorage.getItem('cw_admin_profile');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const value = useMemo(() => ({
    admin,
    isAdminLoggedIn: !!admin || (typeof window !== 'undefined' && !!localStorage.getItem('cw_admin_token')),
    async login(email, password) {
      const { data } = await adminApi.post('/admin/auth/login', { email, password });
      setAdminSession(data.token, data.admin);
      setAdmin(data.admin);
      return data.admin;
    },
    logout() {
      localStorage.removeItem('cw_admin_token');
      persistAdmin(null);
      setAdmin(null);
    },
  }), [admin]);

  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
}

export function useAdminAuth() {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuth must be used inside AdminAuthProvider');
  }
  return context;
}